/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CursorHookPayload,
  CursorHookPayload$Outbound,
  CursorHookPayload$outboundSchema,
} from "../components/cursorhookpayload.js";

export type HooksNumberCursorSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type HooksNumberCursorRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Optional endpoint hostname supplied by the Speakeasy hook plugin.
   */
  xGramHookHostname?: string | undefined;
  /**
   * Optional per-invocation token reused across retries so the server stores a redelivered event exactly once.
   */
  idempotencyKey?: string | undefined;
  cursorHookPayload: CursorHookPayload;
};

/** @internal */
export type HooksNumberCursorSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const HooksNumberCursorSecurity$outboundSchema: z.ZodMiniType<
  HooksNumberCursorSecurity$Outbound,
  HooksNumberCursorSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberCursorSecurityToJSON(
  hooksNumberCursorSecurity: HooksNumberCursorSecurity,
): string {
  return JSON.stringify(
    HooksNumberCursorSecurity$outboundSchema.parse(hooksNumberCursorSecurity),
  );
}

/** @internal */
export type HooksNumberCursorRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "X-Gram-Hook-Hostname"?: string | undefined;
  "Idempotency-Key"?: string | undefined;
  CursorHookPayload: CursorHookPayload$Outbound;
};

/** @internal */
export const HooksNumberCursorRequest$outboundSchema: z.ZodMiniType<
  HooksNumberCursorRequest$Outbound,
  HooksNumberCursorRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    xGramHookHostname: z.optional(z.string()),
    idempotencyKey: z.optional(z.string()),
    cursorHookPayload: CursorHookPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      xGramHookHostname: "X-Gram-Hook-Hostname",
      idempotencyKey: "Idempotency-Key",
      cursorHookPayload: "CursorHookPayload",
    });
  }),
);

export function hooksNumberCursorRequestToJSON(
  hooksNumberCursorRequest: HooksNumberCursorRequest,
): string {
  return JSON.stringify(
    HooksNumberCursorRequest$outboundSchema.parse(hooksNumberCursorRequest),
  );
}
